import { createContext, Dispatch, SetStateAction, useState, useContext, useEffect, useCallback } from 'react';
import { BFObject } from "../types/bfObject";
import { IProps } from "../types/props";
import { v4 as uuidv4 } from 'uuid';
import { IUsuario } from '../types/usuario';
import { LoginApi, registrarCallbackSessaoExpirada } from '../api';

export interface ILogin extends BFObject {
    accessToken: string;
    authenticated: boolean;
    usuario?: IUsuario;
    state?: string;
    mensagemSessaoExpirada?: boolean;
}

interface IPropsLoginContext {
    login: ILogin,
    setLogin: Dispatch<SetStateAction<ILogin>>,
}

const LoginContext = createContext<IPropsLoginContext>({ login: novoLogin() } as IPropsLoginContext);

const LoginProvider = ({ children }: IProps) => {
    const [login, setLogin] = useState<ILogin>(novoLogin());

    const logoutSessaoExpirada = useCallback(() => {
        setLogin(prev => {
            if (!prev.authenticated) return prev;
            return {
                ...novoLogin(),
                state: "SessionExpired",
                mensagemSessaoExpirada: true
            };
        });
    }, []);

    useEffect(() => {
        registrarCallbackSessaoExpirada(logoutSessaoExpirada);
    }, [logoutSessaoExpirada]);

    useEffect(() => {
        const requestLogin = async () => {
          const token = await LoginApi.requestLogin();
    
          if (token) {
            setLogin(prev => ({
                ...prev,
                accessToken: token.accessToken,
                authenticated: true,
                usuario: token.usuario,
                state: "Logged",
                mensagemSessaoExpirada: false
            }));          
          }      
        };
        
        requestLogin();
    }, []);

    return (<LoginContext.Provider value={{
        login,
        setLogin
    }}>
        {children}
    </LoginContext.Provider>);
};

export function useLogin(): [ILogin, Dispatch<SetStateAction<ILogin>>] {
    const context = useContext(LoginContext);
    const { login, setLogin } = context;
    return [login, setLogin];
}

export function novoLogin(): ILogin {
    return {
        id: uuidv4(),
        accessToken: "",
        authenticated: false,
        state: "New",
        mensagemSessaoExpirada: false
    };
}

export { LoginContext, LoginProvider };